import { Spacing } from '@vkontakte/vkui';
import React from 'react';
import { cdnPackagesUrl } from 'reactApp/appHelpers/themeToolHelpers/default-values';
import { renderCommonWhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog.helpers';
import { isDarkThemeModeEnabled } from 'reactApp/utils/theme';

import styles from './FakedoorModal.css';

interface FakedoorModalProps {
    qaId: string;
    title: string;
    text: string;
    primaryButtonText?: string;
    secondaryButtonText?: string;

    onClick?: () => void;
    onClose?: () => void;
    onShow?: () => void;
}

export const renderFakedoorModal = ({
    qaId,
    title,
    text,
    primaryButtonText,
    secondaryButtonText,
    onClick,
    onClose,
}: FakedoorModalProps) => {
    const isDarkTheme = isDarkThemeModeEnabled();

    return renderCommonWhatsNewDialog({
        title,
        content: (
            <div data-test-id={`${qaId}-fakedoor-modal`}>
                <Spacing size={16} />
                <span>{text}</span>
                <Spacing size={32} />
            </div>
        ),
        primaryButtonText,
        primaryButtonClassName: styles.primaryBttn,
        secondaryButtonText,
        imageUrl: '',
        imageOnlyAdditionalContent: true,
        imageAdditionalContent: (
            <div className={styles.secondStepIllustrationWrapper}>
                <img
                    className={styles.secondStepImage}
                    src={`${cdnPackagesUrl}/static/cloud/fakedoor/in-progress${isDarkTheme ? '-dark' : ''}.png`}
                />
            </div>
        ),
        onClick,
        onSecondary: onClose,
        onDismiss: onClose,
        dialogSize: 'tiny',
        buttonTheme: 'vk',
        secondaryButtonColor: 'grey',
        className: styles.root,
        contentClassName: styles.content,
        closeAfterClick: true,
        closeIconClassName: styles.closeIcon,
    });
};
